// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-zir1AZ","footer":"footer-zzl_bF","hidden":"hidden-Ag1ody","item":"item-ggOzsL","active":"active-rDOWCP"};